import React, { useState, useEffect } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material'
import { VisibilityOutlined as VisibilityOutlinedIcon } from '@mui/icons-material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AmountItems from '../AmountItems/AmountItems'
import SearchInput from '../SearchInput'
import { tableColumns, TRAVEL_STATUS } from './data'
import { useDispatch, useSelector } from 'react-redux'
import { SearchContainer, NoData } from './style'
import COLORS from 'utils/colors'
import Pagination from "../Pagination/Pagintions";
import { getTravelList, deleteTravelData } from 'redux/actions/travel'
import Loader from '../Loader'
import { USER_TYPE } from 'utils/commonHelper'
import ReactTable from 'components/common/table/ReactTable2'
import { Link } from 'react-router-dom'
import { GET_TRAVEL_LOG_DETAIL } from '@jumbo/constant/ActionTypes'
import ConfirmDltDialog from 'modules/ConfirmDltDialog'
import AddConfirmDialog from 'modules/AddConfirmDialog'

export default function TravelUser({ navigate, loader, setLoader, activePage, setActivePage, activePerPage, setActivePerPage, tempSearchValue, setTempSearchValue, filterList, tabIndex }) {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(tempSearchValue)
    const [openConfirmDltDialog, setopenConfirmDltDialog] = useState(false)
    const status =
        tabIndex === 1 ? TRAVEL_STATUS.IN_ACTIVE : TRAVEL_STATUS.IN_PROGRESS;
    const currentUser = JSON.parse(localStorage.getItem('profile'))
    const subdiv_user = currentUser.user_type === USER_TYPE.SUBDIVISION_USER
    const tenant_user = currentUser.user_type === USER_TYPE.TENANT_USER

    const { travelList: list } = useSelector(({ TRAVEL }) => TRAVEL)
    const { users } = useSelector(({ CRISISLOGALERT }) => CRISISLOGALERT); // get alert List
    const [selectedTravel, setSelectedTravel] = useState()
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const handleTravelDelete = (travel) => {
        setSelectedTravel(travel);
        setopenConfirmDltDialog(true);
    };
    const handleCancelDelete = () => {
        setopenConfirmDltDialog(false);
    };
    const handleConfirmDelete = () => {
        const params = {
            page: activePage,
            limit: activePerPage,
            search: "",
            status,
        };
        setopenConfirmDltDialog(false);
        dispatch(deleteTravelData(selectedTravel.travelID, { setAddDialog: () => setOpenConfirmDialog(true) }, () => dispatch(
            getTravelList(params)
        )))
    };
    const handleCancelConfirm = () => {
        setOpenConfirmDialog(false)
    }
    const handleConfirm = () => {
        setOpenConfirmDialog(false)
    }

    useEffect(() => {
        //setTimeout(() => setLoader(false), 3000)
    }, [])

    const changePerPage = (activePerPage) => {
        setActivePerPage(activePerPage);
        setLoader(true)
        const subdivisions = filterList.length === 0 ? '' : filterList.length === 1 ? filterList[0] : filterList.join(',')
        const params = { page: 1, limit: activePerPage, search: searchValue, subdivisions, status }
        const paramsTab = tabIndex === 1 ? { ...params, sortBy: "" } : params
        dispatch(getTravelList(paramsTab))
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        setLoader(true)
        const subdivisions = filterList.length === 0 ? '' : filterList.length === 1 ? filterList[0] : filterList.join(',')
        const params = { page: pageNumber, limit: activePerPage, search: searchValue, subdivisions, status }
        const paramsTab = tabIndex === 1 ? { ...params, sortBy: "" } : params
        dispatch(getTravelList(paramsTab))
    }

    const onSubmitSearch = (e) => {
        e.preventDefault();
        setLoader(true)
        setTempSearchValue(searchValue)
        const subdivisions = filterList.length === 0 ? '' : filterList.length === 1 ? filterList[0] : filterList.join(',')
        const params = { page: activePage, limit: activePerPage, search: searchValue, subdivisions, status }
        dispatch(getTravelList(params))
    }

    const clearSearch = (e) => {
        e.preventDefault();
        setTempSearchValue("");
        setSearchValue("");
        setLoader(true)
        const subdivisions = filterList.length === 0 ? '' : filterList.length === 1 ? filterList[0] : filterList.join(',')
        let params = { page: activePage, limit: activePerPage, search: '', status }
        if (currentUser?.user_type == 2) params = { page: activePage, limit: activePerPage, search: '', status, subdivisions }
        const paramsTab = tabIndex === 1 ? { ...params, sortBy: "" } : params
        dispatch(getTravelList(paramsTab));
    }

    const renderLoader = () => {
        return (
            <Loader />
        )
    }
    const testMode = () => {
        return (
            <div className="default-number" style={{ marginTop: "4px" }}>
                Test Mode
            </div>
        );
    };
    const columns = tabIndex === 1 ? [
        {
            id: 'id',
            accessor: 'id',
            title: 'ID'
        },
        {
            id: 'userFirstname',
            accessor: 'userFirstname',
            title: 'Full Name',
            Component: ({ row }) => {
                return (
                    <>
                        {row?.test_mode && <div className="default-number" style={{ marginTop: "4px" }}>
                            Test Mode
                        </div>}
                        <div>{`${row?.userFirstname || ""} ${row?.userLastname || "-"} `}</div>
                    </>
                );
            }
        },
        // {
        //     id: 'lastCheckinCountry',
        //     accessor: 'lastCheckinCountry',
        //     title: 'Last Country'
        // },
        // {
        //     id: 'lastCheckinCity',
        //     accessor: 'lastCheckinCity',
        //     title: 'Last City'
        // },
        {
            id: 'country',
            accessor: 'country',
            title: 'End Country'
        },
        {
            id: 'city',
            accessor: 'city',
            title: 'End City'
        },
        {
            id: 'userMobile',
            accessor: 'userMobile',
            title: 'Phone number'
        },
        {
            id: 'userEmail',
            accessor: 'userEmail',
            title: 'Email'
        },
        {
            id: 'actions',
            accessor: 'actions',
            title: 'Actions',
            width: '6%',
            Component: ({ row }) => {
                return (
                    <div className='flex justify-center'>
                        <Link to={`/app/Travel/travel-detail/${row.travelID}`} className='mt-1'>
                            <i className="icon-eye actioneye" />
                        </Link>
                        {currentUser && ([USER_TYPE.CONTROL_USER, USER_TYPE.SUBDIVISION_USER, USER_TYPE.EXTERNAL_CONTROLLER, USER_TYPE.SEC_CONTROLLER].includes(currentUser?.user_type) || currentUser?.control_user) &&
                            <button type='button' className="text-[#e17070] ml-2 cursor-pointer" onClick={() => handleTravelDelete(row)}>
                                Delete
                            </button>}
                    </div>
                )
            }
        },
    ] : [
        {
            id: 'id',
            accessor: 'id',
            title: 'ID'
        },
        {
            id: 'userFirstname',
            accessor: 'userFirstname',
            title: 'Full Name',
            Component: ({ row }) => {
                return (
                    <>
                        {row?.test_mode && <div className="default-number" style={{ marginTop: "4px" }}>
                            Test Mode
                        </div>}
                        <div>{`${row?.userFirstname || ""} ${row?.userLastname || "-"} `}</div>
                    </>
                );
            }
        },
        {
            id: 'lastCheckinCountry',
            accessor: 'lastCheckinCountry',
            title: 'Last Country'
        },
        {
            id: 'lastCheckinCity',
            accessor: 'lastCheckinCity',
            title: 'Last City'
        },
        {
            id: 'country',
            accessor: 'country',
            title: 'End Country'
        },
        {
            id: 'city',
            accessor: 'city',
            title: 'End City'
        },
        {
            id: 'userMobile',
            accessor: 'userMobile',
            title: 'Phone number'
        },
        {
            id: 'userEmail',
            accessor: 'userEmail',
            title: 'Email'
        },
        {
            id: 'actions',
            accessor: 'actions',
            title: 'Actions',
            width: '6%',
            Component: ({ row }) => {
                return (
                    <>
                        <Link to={`/app/Travel/travel-detail/${row.travelID}`}>
                            <i className="icon-eye actioneye" />
                        </Link>
                    </>
                )
            }
        },
    ];

    useEffect(() => {
        dispatch({ type: GET_TRAVEL_LOG_DETAIL, payload: [] });
    }, [])

    return (
        <div>
            <SearchContainer>
                <SearchInput searchValue={searchValue} onChange={(searchValue) => setSearchValue(searchValue)} onSubmit={onSubmitSearch} clearSearch={clearSearch} />
                <AmountItems changePerPage={(item) => changePerPage(item)} activePerPage={activePerPage} />
            </SearchContainer>
            <ReactTable
                COLUMNS={columns}
                DATA={list?.UserTravelList || []}
                fetchData={handlePageChange}
                totalCount={tabIndex == 1 ? list?.total_upcoming : list?.total_no_of_records}
                pageSize={activePerPage}
                pageIndex={activePage}
                hiddenColumns={![USER_TYPE.SUBDIVISION_USER, USER_TYPE.EXTERNAL_CONTROLLER, USER_TYPE.END_USER, USER_TYPE.SEC_CONTROLLER].includes(currentUser.user_type) ? ['actions'] : []}
            />
            <ConfirmDltDialog
                open={openConfirmDltDialog}
                content={`Are you sure you want to delete this travel plan?`}
                content1={'All information about this Travel will be permanently deleted.'}
                btnLabels={{
                    no: "No",
                    Yes: "Yes",
                }}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
            />
            <AddConfirmDialog
                open={openConfirmDialog}
                // title={`Delete Subdivision`}
                content={`Travel plan deleted successfully!`}
                btnLabels={{
                    ok: "Ok",
                }}
                onClose={handleCancelConfirm}
                onConfirm={handleConfirm}
            />
        </div>
    )
} 